export function getBuyNumberPlanType(product) {
  return product?.user?.payment_details?.type || '3'
}

export function getBuyNumberPlanPrice(product) {
  if (product?.hot) return '1000000'
  return product?.user?.payment_details?.amount || '70000'
}

export function getMemberSince(product) {
  return product?.user?.createdAt || ''
}

export function formatDaysPassedLabel(days) {
  const safeDays = days || 0
  return { isToday: safeDays === 0, days: safeDays }
}